import { render } from "./ModelViewerWrapper.vue?vue&type=template&id=662f1cff&scoped=true"
import script from "./ModelViewerWrapper.vue?vue&type=script&lang=js"
export * from "./ModelViewerWrapper.vue?vue&type=script&lang=js"

import "./ModelViewerWrapper.vue?vue&type=style&index=0&id=662f1cff&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-662f1cff"]])

export default __exports__